import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;

export const rowData: Array<any> = [
  {
    fieldName: 'name',
    width: '25%',
  }, {
    fieldName: 'subGroups',
    fieldMap: 'sub_groups',
    width: '25%',
    disabled: true,
  }, {
    fieldName: 'code',
    width: '25%',
  }, {
    fieldName: 'item_count',
    width: '25%',
    disabled: true,
    numerical: true,
  },
];

export const contentData: Array<any> = [
  [{
    fieldName: 'description',
    width: '100%',
    type: DetailsControlType.Textarea,
  }],
];

export const subGroupData: Array<any> = [
  {
    fieldName: 'sub_group_name',
    fieldMap: 'name',
    width: '50%',
    type: DetailsControlType.Textarea,
  }, {
    fieldName: 'sub_group_code',
    fieldMap: 'code',
    width: '25%',
    type: DetailsControlType.Textarea,
  }, {
    fieldName: 'sub_group_item_count',
    fieldMap: 'item_count',
    width: '15%',
    disabled: true,
  },
];
